module.exports = __webpack_public_path__ + "fonts/a_calling_font_d_by_7ntypes-webfont.1c1ee74f.woff2";